// packages/api/src/admin/request.ts

import { apiClient } from '../client';
import { RequestDTO, RequestQueryParams, Create_Update_BranchPayload } from '../../../contract/dtos';
import { ApiResponse } from '../../../contract/types';



// Get request information with query parameters
export const getRequest = async (params?: RequestQueryParams): Promise<ApiResponse<RequestDTO[]>> => {
  const response = await apiClient.get('/corporate/v1/request', {
    params: {
      ...params,
    },
  });
  const total = parseInt(response.headers['x-total-count'] || '0', 10);
  const totalPages = Math.ceil(total / (params?.size || total));
  return {
    data: response.data,
    total,
    totalPages,
  };
};

export const getRequestById = async (params?: RequestQueryParams): Promise<ApiResponse<RequestDTO>> => {
    const response = await apiClient.get('/corporate/v1/request', {
      params
    });
    return {
      data: response.data[0],
    };
  };

// Define the response type if needed, or use any
//should be changed later
export const CreateRequestBranch = async (
  requestId: number,
  payload: Create_Update_BranchPayload
): Promise<any> => {
  const response = await apiClient.put(`/corporate/v1/request/${requestId}/branch`, payload);
  return response.data;
};

// Add the new API function for updating a specific branch
export const updateRequestBranch = async (
  requestId: number,
  branchId: number,
  payload: Create_Update_BranchPayload
): Promise<any> => {
  const response = await apiClient.put(
    `/corporate/v1/request/${requestId}/branch/${branchId}`,
    payload
  );
  return response.data;
};


export const activateRequest = async (requestId: number): Promise<any> => {
  const response = await apiClient.put(`/corporate/v1/request/${requestId}/activate`, {});
  return response.data;
};